import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const AiUsageView = lazy(() => import('./AiUsageView'));

const route: FuseRouteItemType = {
	path: 'ai-usage',
	element: <AiUsageView />
};

export default route;
